(function () {
    'use strict';

    angular
        .module('elogbooks.admin.users')
        .controller('UserOperativeController', UserOperativeController);

    UserOperativeController.$inject = [
        'apiClient',
        'lodash',
        'confirmationModal',
        'operativesResponse',
        'userResponse',
        'operativePermissions',
        'rootResourceResponse',
        'messenger',
        'filterPermissions',
        'serviceProviderCollectionResponse',
        '$scope'
    ];

    function UserOperativeController(
        apiClient,
        lodash,
        confirmationModal,
        operativesResponse,
        userResponse,
        operativePermissions,
        rootResourceResponse,
        messenger,
        filterPermissions,
        serviceProviderCollectionResponse,
        $scope
    ) {

        var vm = this;
        vm.loadOperatives = loadOperatives;
        vm.addOperative = addOperative;
        vm.deleteOne = deleteOne;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        vm.removeSinglePermission = removeSinglePermission;
        vm.addPermissions = addPermissions;
        vm.removeServiceProviders = removeServiceProviders;
        vm.operatives = operativesResponse.getData().operatives;
        vm.pages = operativesResponse.getData().pages;
        vm.operativesResponse = operativesResponse;
        vm.rootResourceResponse = rootResourceResponse;
        vm.removePermissions = removePermissions;
        vm.permissions = operativePermissions.getAllTranslated();
        vm.selectedPermissions = [];
        vm.selectedServiceProviders = [];
        vm.selectedOperatives = [];
        vm.allSelected = false;

        vm.serviceProviderCollectionResponse = serviceProviderCollectionResponse;
        vm.OriginalServiceProviderCollectionResponse = angular.copy(serviceProviderCollectionResponse);

        vm.serviceProvidersSelect = {
            response: vm.OriginalServiceProviderCollectionResponse,
            link: vm.rootResourceResponse ? vm.rootResourceResponse.getLink('serviceproviders') : null,
            responseKeyPath: 'serviceproviders',
            itemHrefPath: '_links.self.href',
            linkParameters: { excludeOperative: userResponse.id }
        };

        vm.form = null;
        vm.formControll = null;

        vm.setForm = (form) => {
            vm.form = form;

            let findController = (scope) =>
                scope.hasOwnProperty('vm') ? scope.vm :
                    (scope.hasOwnProperty('$parent') ? findController(scope.$parent) : null);

            let controller = findController($scope.$parent);
            if (controller && controller.formControll) {
                vm.formControll = controller.formControll;
                controller.formControll.setForm(form);
            }
        }

        angular.forEach(vm.operatives, function (value, index) {
            vm.operatives[index].permissions = filterPermissions.filterAllowedPermissions(vm.operatives[index].permissions, operativePermissions.getAll());
            vm.operatives[index].checked = false;
        });

        function loadOperatives() {
            apiClient.getPage(operativesResponse.getLink('self'), {
                datagroup: 'list',
                limit: 30
            }).then(function (response) {
                vm.operatives = response.getData().operatives;
                vm.pages = response.getData().pages;
                vm.allSelected = false;
                vm.selectedOperatives = [];
                vm.selectedServiceProviders = [];
            });
            loadServiceProviders();
        }

        function loadServiceProviders() {
            apiClient.getPage(vm.rootResourceResponse.getLink('serviceproviders'), {
                datagroup: 'list',
                limit: 30,
                excludeOperative: userResponse.id
            }).then(function (response) {
                vm.serviceProvidersSelect.response = response.getData();
            });
        }

        function addOperative() {
            if (!vm.selectedServiceProviders.length) {
                return;
            }

            vm.formControll && vm.formControll.setFormDirty();

            // Create a batch request with all selected service providers
            const requestData = {
                _links: {
                    serviceProviders: vm.selectedServiceProviders.map(function(serviceProvider) {
                        return {
                            href: serviceProvider.href
                        };
                    })
                }
            };

            apiClient.create(userResponse.getLink('operatives'), requestData)
                .then(function() {
                    vm.formControll && vm.formControll.setFormNotDirty();
                    vm.selectedServiceProviders = [];
                    vm.loadOperatives();
                    messenger.success('SERVICE_PROVIDERS_UPDATED');
                });
        }

        function removeServiceProviders() {
            if (!vm.selectedOperatives.length) {
                return;
            }

            confirmationModal.open({
                bodyMessage: 'USER_OPERATIVE_REMOVAL_WARNING'
            }).result.then(
                function() {
                    vm.formControll && vm.formControll.setFormDirty();
                    const requestData = {
                        _links: {
                            operatives: vm.selectedOperatives.map(function(operative) {
                                return {
                                    href: operative._links.self.href
                                };
                            })
                        }
                    };

                    apiClient.update(userResponse.getLink('operatives'), requestData)
                        .then(function() {
                            vm.formControll && vm.formControll.setFormNotDirty();
                            vm.loadOperatives();
                            messenger.success('SERVICE_PROVIDERS_UPDATED');
                    });
                }
            );
        }

        function deleteOne(operative) {
            return confirmationModal.open().result.then(
                function() {
                    // YES was clicked
                    vm.formControll && vm.formControll.setFormDirty();

                    apiClient.delete(operative._links.delete.href).then(function (response) {
                        vm.formControll && vm.formControll.setFormNotDirty();

                        if (response) {
                            vm.loadOperatives();
                             messenger.success('SERVICE_PROVIDERS_UPDATED');
                        }
                    });
                },
                function() {
                    // NO was clicked
                }
            );
        }

        function toggleAll(allSelected) {
            vm.selectedOperatives = [];
            if (allSelected) {
                lodash.each(vm.operatives, function (operative) {
                    operative.checked = true;
                    vm.selectedOperatives.push(operative);
                });
            } else {
                lodash.each(vm.operatives, function (operative) {
                    operative.checked = false;
                });
            }
        }

        function toggleOne(operative) {
            if (operative.checked) {
                vm.selectedOperatives.push(operative);
            } else {
                vm.selectedOperatives = lodash.without(vm.selectedOperatives, operative);
            }
        }

        function removeSinglePermission(operative, permission) {
            operative.permissions = lodash.without(operative.permissions, permission);

            vm.formControll && vm.formControll.setFormDirty();
            apiClient.update(operative._links.self.href, { permissions: operative.permissions }).then(function (response) {
                vm.formControll && vm.formControll.setFormNotDirty();

                if (!response) {
                    operative.permissions.push(permission);
                }
                else {
                    messenger.success('SERVICE_PROVIDER_PERMISSIONS_UPDATED');
                }
            });
        }

        function addPermissions() {
            var requestData = {
                _links: {
                    operative: []
                },
                additions: []
            }, permissions = [];

            lodash.each(vm.selectedPermissions, function (permission) {
                permissions.push(permission.label);
            });

            requestData.additions = permissions;
            lodash.each(vm.selectedOperatives, function (operative) {
                requestData._links.operative.push(operative._links.self);
                operative.permissions = lodash.union(operative.permissions, permissions);
            });

            vm.formControll && vm.formControll.setFormDirty();

            // TODO use advertised link when EWV-425 is complete
            apiClient.create(userResponse.getLink('operatives') + '/permission-changeset', requestData).then(function (response) {
                vm.formControll && vm.formControll.setFormNotDirty();
                messenger.success('SERVICE_PROVIDER_PERMISSIONS_UPDATED');
            });
        };

        function removePermissions() {
            var requestData = {
                _links: {
                    operative: []
                },
                subtractions: []
            }, permissions = [];
            lodash.each(vm.selectedPermissions, function (permission) {
                permissions.push(permission.label);
            });
            requestData.subtractions = permissions;
            lodash.each(vm.selectedOperatives, function (operative) {
                requestData._links.operative.push(operative._links.self);
                operative.permissions = lodash.difference(operative.permissions, permissions);
            });

            vm.formControll && vm.formControll.setFormDirty();
            // TODO use advertised link when EWV-425 is complete
            apiClient.create(userResponse.getLink('operatives') + '/permission-changeset', requestData).then(function (response) {
                vm.formControll && vm.formControll.setFormNotDirty();
                messenger.success('SERVICE_PROVIDER_PERMISSIONS_UPDATED');
            });
        }
    }
})();
